module.exports = __webpack_public_path__ + "static/media/app_store_badge_us_white_copy_2.7e45556f.svg";